

export default function Icon({ name, className = "w-5 h-5" }) {
  const paths = {
    spark: (
      <path
        d="M12 2l1.8 4.7L18 8.5l-4.2 1.8L12 15l-1.8-4.7L6 8.5l4.2-1.8L12 2z"
        fill="currentColor"
        className="opacity-90"
      />
    ),
    rocket: (
      <>
        {/* Robot head - larger */}
        <rect x="4" y="3" width="16" height="16" rx="3" fill="currentColor" />
        {/* Eyes - friendly */}
        <circle cx="9" cy="9" r="2" fill="#fff" />
        <circle cx="15" cy="9" r="2" fill="#fff" />
        {/* Mouth - neutral friendly curve */}
        <path d="M9 15c1.5 1 4.5 1 6 0" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" />
        {/* Antenna */}
        <line x1="12" y1="3" x2="12" y2="1.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <circle cx="12" cy="1.5" r="1" fill="currentColor" />
      </>
    ),
    shield: (
      <path
        d="M12 3l7 3v6c0 5-3.6 7.7-7 9-3.4-1.3-7-4-7-9V6l7-3z"
        fill="currentColor"
      />
    ),
    chart: (
      <path d="M4 20h16M7 16v-6M12 20V8m5 12v-9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    ),
    cluster: (
      <path d="M6 6h.01M18 6h.01M12 4h.01M4 12h.01M20 12h.01M6 18h.01M18 18h.01M12 20h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    ),
    time: (
      <path d="M12 6v6l4 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    ),
    mail: (
      <path d="M3 7l9 6 9-6M5 6h14a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2z" stroke="currentColor" strokeWidth="1.5" fill="none" />
    ),
    map: (
      <path d="M9 6l6-2 6 2v12l-6-2-6 2-6-2V4l6 2z" stroke="currentColor" strokeWidth="1.5" fill="none" />
    ),
    phone: (
      <path d="M4 5c0 7 8 15 15 15l2-4-5-3-3 2c-3-1-6-4-7-7l2-3-3-5-4 2z" stroke="currentColor" strokeWidth="1.5" fill="none" />
    ),
      trendingup: (
      <path d="M3 17l6-6 4 4 8-8" stroke="currentColor" strokeWidth="1.5" fill="none" strokeLinecap="round" />
    ),
    target: (
      <path d="M12 2a10 10 0 100 20 10 10 0 000-20zm0 4a6 6 0 110 12 6 6 0 010-12zm0 2a4 4 0 100 8 4 4 0 000-8z" stroke="currentColor" strokeWidth="1.5" fill="none"/>
    )
  };
  return (
    <svg viewBox="0 0 24 24" aria-hidden className={className}>
      {paths[name]}
    </svg>
  );
}